const currentYear = () => {
  return new Date().getFullYear();
};
export const CopyrightConstant = {
  mainLine: 'All trademarks are properties of their respective owners.',
  date: `2017-${currentYear()}©Blupin Technologies Pvt Ltd. All rights reserved.`,
};
